import { render, staticRenderFns } from "./VideoLinks.vue?vue&type=template&id=1de70702&scoped=true"
import script from "./VideoLinks.vue?vue&type=script&lang=js"
export * from "./VideoLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de70702",
  null
  
)

export default component.exports